//@ts-check
import React from 'react';

/**
 *
 * @param {{children:React.ReactNode}} param0
 */
export const TagsContainer = ({ children }) => {
  return (
    <>
      <p className="font-bold text-lg text-[#0D1117] dark:text-gray-50 !m-0">
        Projetos e Linhas de Pesquisa:
      </p>
      <div className="flex flex-row gap-x-3 gap-y-2 md:justify-start justify-center flex-wrap text-lg">
        {children}
      </div>
    </>
  );
};
